<template>
  <div class="classifyInfoRoot">
    <div class="linkInfoPage divContainer collectionModule">
      <div v-if="loading" v-loading="loading" class="fullContainer" />
      <div v-else-if="loadError" class="linkInfoPage__error">
        <p class="linkInfoPage__errorTitle">设计师加载失败</p>
        <p class="linkInfoPage__errorDesc link-text-muted">{{ loadError }}</p>
        <el-button size="small" type="primary" @click="goBack">返回列表</el-button>
      </div>
      <div v-else class="linkInfoPage__layout resourceFormPage__layout">
        <div class="resourceFormPage__headerDock">
          <header class="resourceFormPage__actionBar">
            <div class="resourceFormPage__lead">
              <h1 class="resourceFormPage__pageTitle">查看设计师</h1>
            </div>
            <div class="resourceFormPage__actions">
              <button
                type="button"
                class="resourceFormPage__btn resourceFormPage__btn--ghost"
                @click="goResources"
              >
                资源列表
              </button>
              <button
                type="button"
                class="resourceFormPage__btn resourceFormPage__btn--ghost"
                v-check-role
                @click="toggleOnline"
              >
                {{ ruleForm.status === 1 ? '上线' : '下线' }}
              </button>
              <el-popconfirm
                :title="ruleForm.isAuth === 0 ? '确认改为已认证？' : '确认取消认证？'"
                @confirm="toggleAuth"
              >
                <button
                  slot="reference"
                  type="button"
                  class="resourceFormPage__btn resourceFormPage__btn--ghost"
                  v-check-role
                >
                  {{ ruleForm.isAuth === 0 ? '认证' : '取消认证' }}
                </button>
              </el-popconfirm>
              <button
                type="button"
                class="resourceFormPage__btn resourceFormPage__btn--primary"
                v-check-role
                :disabled="ruleForm.isAuth === 0"
                @click="goEdit"
              >
                编辑
              </button>
            </div>
          </header>
        </div>
        <main class="linkInfoPage__main resourceFormPage__main main">
          <el-form label-position="top" size="small" :model="ruleForm" disabled>
            <designer-form-shell
              :rule-form="ruleForm"
              :is-create="false"
              readonly
            />
          </el-form>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import {
  designerAuth,
  getDesignerById,
  onOrOff,
} from '../../../api/designerManage'
import { mutations } from '../../../utils/store'
import DesignerFormShell from './DesignerFormShell.vue'
import { applyDesignerDetail, emptyDesignerForm } from './designerFormModel'

export default {
  name: 'DesignerInfo',
  components: { DesignerFormShell },
  data() {
    return {
      ruleForm: emptyDesignerForm(),
      loading: false,
      loadError: '',
    }
  },
  created() {
    this.loadDetail()
  },
  methods: {
    setBreadTitle: mutations.setBreadTitle,
    loadDetail() {
      this.loading = true
      this.loadError = ''
      getDesignerById({ id: this.$route.params.id })
        .then((res) => {
          if (!res.success) {
            this.loadError = res.errMessage || '没有读到设计师'
            return
          }
          this.ruleForm = applyDesignerDetail(res.data)
          if (this.ruleForm.name) {
            this.setBreadTitle(`${this.ruleForm.name}-查看`)
          }
        })
        .catch(() => {
          this.loadError = '没有读到设计师'
        })
        .finally(() => {
          this.loading = false
        })
    },
    toggleOnline() {
      const nextLabel = this.ruleForm.status === 1 ? '上线' : '下线'
      this.$confirm(`确认改为${nextLabel}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => onOrOff({ id: this.$route.params.id }))
        .then((res) => {
          if (res && res.success) {
            this.$message.success('状态已更新')
            this.loadDetail()
          }
        })
        .catch(() => {})
    },
    toggleAuth() {
      designerAuth({ id: Number(this.$route.params.id), authMessage: '' }).then((res) => {
        if (!res.success) return
        this.$message.success('认证状态已更新')
        this.loadDetail()
      })
    },
    goEdit() {
      if (this.ruleForm.isAuth === 0) return
      this.$router.push(`/resource/designer/edit/${this.$route.params.id}`)
    },
    goResources() {
      const name = this.ruleForm.name || ''
      this.$router.push(
        `/resource/designer/resources/${this.$route.params.id}?name=${encodeURIComponent(name)}`
      )
    },
    goBack() {
      this.$router.push('/resource/designer/list')
    },
  },
}
</script>

<style scoped>
.fullContainer {
  width: 100%;
  height: 100%;
}
</style>
